import { axiosInstance } from "../../utils";

const actions = {
  FETCH_INSURANCE_COMPANIES_REQUESTED: "FETCH_INSURANCE_COMPANIES_REQUESTED",
  FETCH_INSURANCE_COMPANIES_SUCCEEDED: "FETCH_INSURANCE_COMPANIES_SUCCEEDED",
  FETCH_INSURANCE_COMPANIES_FAILED: "FETCH_INSURANCE_COMPANIES_FAILED",

  FETCH_INSURANCE_COMPANY_REQUESTED: "FETCH_INSURANCE_COMPANY_REQUESTED",
  FETCH_INSURANCE_COMPANY_SUCCEEDED: "FETCH_INSURANCE_COMPANY_SUCCEEDED",
  FETCH_INSURANCE_COMPANY_FAILED: "FETCH_INSURANCE_COMPANY_FAILED",

  DELETE_INSURANCE_COMPANY_REQUESTED: "DELETE_INSURANCE_COMPANY_REQUESTED",
  DELETE_INSURANCE_COMPANY_SUCCEEDED: "DELETE_INSURANCE_COMPANY_SUCCEEDED",
  DELETE_INSURANCE_COMPANY_FAILED: "DELETE_INSURANCE_COMPANY_FAILED",

  removeInsuranceCompany: (id = undefined) => ({
    type: actions.DELETE_INSURANCE_COMPANY_REQUESTED,
    payload: id,
  }),

  deleteInsuranceCompany: async (id = undefined) => {
    const url = `insurance_companies/${id}`;
    const response = await axiosInstance.delete(url);
    return response.data;
  },

  fetchInsuranceCompanies: (params = undefined) => ({
    type: actions.FETCH_INSURANCE_COMPANIES_REQUESTED,
    payload: params,
  }),

  fetchInsuranceCompany: (id = undefined) => ({
    type: actions.FETCH_INSURANCE_COMPANY_REQUESTED,
    payload: id,
  }),

  getInsuranceCompanies: async (params = undefined) => {
    const url = `insurance_companies`;
    const response = await axiosInstance.get(url, { params });
    return response.data;
  },

  getInsuranceCompany: async (companyId = undefined) => {
    const url = `insurance_companies`;
    const response = await axiosInstance.get(url, {
      params: { _id: companyId, limit: 1, page: 1 },
    });
    const row = response.data?.data?.[0];
    if (!row) throw new Error("Insurance company not found");
    return { insurance_company: row };
  },
};

export default actions;
